module.exports = __webpack_public_path__ + "static/media/zoomy2.0920c8f0.jpg";